const { registerBlockType } = wp.blocks;
const { __ } = wp.i18n;
const { TextControl, ToggleControl } = wp.components;
const { serverSideRender } = wp;

import edit from './edit.js';
import save from './save.js';

registerBlockType('pretix-widget/widget', {
	title: __('pretix Widget', 'pretix-widget'),
	description: __('A widget for displaying pretix widget.', 'pretix-widget'),
	icon: 'tickets-alt',
	category: 'widgets',
	attributes: {
		pretixEvent: {
			type: 'string',
			default: '',
		},
		subEvent: {
			type: 'string',
			default: '',
		},
		variant: {
			type: 'string',
			default: '',
		},
		hideEventTitle: {
			type: 'boolean',
			default: false,
		},
	},
	edit,
	save,
});
